import { Injectable } from '@angular/core';
import { Pet, PetProfileFormValues } from '@app/core/models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '..';
import {
  autoSaveNewPet,
  resetPatientProfileState,
  setIsNewPet,
  setOngoingPet,
  setPatientProfile,
  setPatientWeight,
} from './patient-profile.actions';
import { selectIsNewPet, selectOngoingPet, selectProfile, selectWeight, selectPetHasGrowthChart } from './patient-profile.selectors';
import { WeightFormValue } from '@app/shared/components/weight-form/weight-form';
import { Tool } from '@app/shared/utils';
import { SystemPreferenceCode } from '@app/shared/utils/enums/system-preference-code';

@Injectable()
export class PatientProfileFacade {
  public profile$: Observable<PetProfileFormValues> = this.store$.pipe(select(selectProfile));
  public weight$: Observable<WeightFormValue> = this.store$.pipe(select(selectWeight));
  public isNewPet$: Observable<boolean> = this.store$.pipe(select(selectIsNewPet));
  public ongoingPet$: Observable<Pet> = this.store$.pipe(select(selectOngoingPet));
  public petHasGrowthChart$ = (currentSystemPreferenceCode: SystemPreferenceCode) =>
    this.store$.select(selectPetHasGrowthChart(currentSystemPreferenceCode));

  constructor(private readonly store$: Store<AppState>) {}

  setPatientProfile(profile: PetProfileFormValues): void {
    this.store$.dispatch(setPatientProfile({ profile }));
  }

  setPatientWeight(weight: WeightFormValue, tool: Tool): void {
    this.store$.dispatch(setPatientWeight({ weight, tool }));
  }

  setIsNewPet(isNewPet: boolean): void {
    this.store$.dispatch(setIsNewPet({ isNewPet }));
  }

  setOngoingPet(ongoingPet: Pet): void {
    this.store$.dispatch(setOngoingPet({ ongoingPet }));
  }

  autoSaveNewPet(tool: Tool): void {
    this.store$.dispatch(autoSaveNewPet({ tool }));
  }

  resetPatientProfileState(): void {
    this.store$.dispatch(resetPatientProfileState());
  }
}
